import { Validator } from './Parser/Visitor';
export var FFuncType;
(function (FFuncType) {
    FFuncType["AGG"] = "AGG";
    FFuncType["SCALAR"] = "SCALAR";
})(FFuncType || (FFuncType = {}));
export class FFuncBase {
    constructor(name, args) {
        this._name = name;
        this._args = args;
        this._argc = (args || []).length;
        this._id = `F-${name}-${Math.random().toString(16).slice(2, 6)}`;
    }
    get id() {
        return this._id;
    }
    get name() {
        return this._name;
    }
    get args() {
        return this._args;
    }
    get argc() {
        return this._argc;
    }
}
export class FFuncAgg extends FFuncBase {
    get type() {
        return FFuncType.AGG;
    }
}
export class FFuncScalar extends FFuncBase {
    get type() {
        return FFuncType.SCALAR;
    }
}
export class FCalcAgg extends FFuncAgg {
    constructor(name, expr) {
        super(name);
        this._expr = expr;
    }
    get expr() {
        return this._expr;
    }
    init(scope) {
        this.expr.init(scope);
    }
    step(scope, ...args) {
        this.expr.step(scope);
    }
    final(scope) {
        return this.expr.final(scope);
    }
    getReturnType(argTypes) {
        return this.expr.returnType;
    }
}
export class FCalcScalar extends FFuncScalar {
    constructor(name, expr) {
        super(name);
        this._expr = expr;
    }
    get expr() {
        return this._expr;
    }
    value(scope, ...args) {
        return this.expr.value(scope);
    }
    getReturnType(argTypes) {
        return this.expr.returnType;
    }
}
export class FFuncResolver extends Validator {
    constructor(provider) {
        super();
        this._provider = provider;
        this._functions = new Map();
    }
    get provider() {
        return this._provider;
    }
    get functions() {
        return this._functions;
    }
    getFunc(offset) {
        return this.functions.get(offset);
    }
    getCalcFunc(field) {
        return this.provider.getCalcFunc(field);
    }
    visitCallExpressionNode(node) {
        const func = this.provider.getFunc(node.callee, node.arguments);
        if (func != null) {
            this.functions.set(this.getNodeId(node), func);
        }
        else {
            this.addError(node, `Unknown function ${node.callee}`);
        }
    }
}
